import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "regenerator-runtime/runtime.js";
import Nl2br from 'vue-nl2br';
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
var DuelTabs = function DuelTabs() {
  return import('@/components/organisms/DuelTabs');
};
export default {
  components: {
    Nl2br: Nl2br,
    PageTitle: PageTitle,
    DuelTabs: DuelTabs
  },
  data: function data() {
    return {
      isLoading: false,
      myRank: {},
      rankingList: [],
      guildInfos: [],
      wpIds: [],
      currentWpId: 0,
      currentWpInfo: {},
      wpInfo: {},
      pastWpInfos: [],
      activeWpId: 0
    };
  },
  watch: {
    activeWpId: function activeWpId() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchRankingData();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  computed: {
    me: function me() {
      return useUserStore().me;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    getSince: function getSince() {
      if (!Object.keys(this.wpInfo).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var since = new Date(this.wpInfo.winnerPointMaster.eventPeriod.since * 1000).toLocaleString(locale, options);
      return since;
    },
    getUntil: function getUntil() {
      if (!Object.keys(this.wpInfo).length) return '';
      var locale = this.$i18n.locale;
      var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      };
      var until = new Date(this.wpInfo.winnerPointMaster.eventPeriod.until * 1000).toLocaleString(locale, options);
      return until;
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _this2.isLoading = true;
            _context2.next = 3;
            return _this2.$duelsService.getWinnerPointIds();
          case 3:
            _this2.wpIds = _context2.sent;
            _this2.currentWpId = _this2.wpIds.currentWpId;
            _context2.next = 7;
            return _this2.$duelsService.getWinnerPointInfo(_this2.currentWpId);
          case 7:
            _this2.currentWpInfo = _context2.sent;
            _this2.activeWpId = _this2.currentWpId;
            // await this.fetchRankingData()
          case 9:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  },
  methods: {
    fetchRankingData: function fetchRankingData() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var uids, guildIds;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.isLoading = true;
              _context3.next = 3;
              return _this3.$duelsService.getWinnerPoint(_this3.activeWpId, _this3.me.uid);
            case 3:
              _this3.myRank = _context3.sent;
              _context3.next = 6;
              return _this3.$duelsService.getWinnerPointInfo(_this3.activeWpId);
            case 6:
              _this3.wpInfo = _context3.sent;
              _context3.next = 9;
              return _this3.$duelsService.getWinnerPointMasters(_this3.wpIds.pastWpIdsList);
            case 9:
              _this3.pastWpInfos = _context3.sent;
              _context3.next = 12;
              return _this3.$duelsService.getWinnerPoints(_this3.activeWpId, 0, 100);
            case 12:
              _this3.rankingList = _context3.sent;
              uids = [];
              _this3.rankingList.forEach(function (l) {
                uids.push(l.uid);
              });
              if (!uids.length) {
                _context3.next = 24;
                break;
              }
              _context3.next = 18;
              return useUserStore().fetchUsers(uids);
            case 18:
              guildIds = [];
              uids.forEach(function (u) {
                if (_this3.getUser(u).guildId > 0) {
                  guildIds.push(_this3.getUser(u).guildId);
                }
              });
              if (!guildIds.length) {
                _context3.next = 24;
                break;
              }
              _context3.next = 23;
              return _this3.$landGuildService.GetGuildInfos(guildIds);
            case 23:
              _this3.guildInfos = _context3.sent;
            case 24:
              _this3.isLoading = false;
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    userProfilePic: function userProfilePic(user) {
      if (user.ipfs) {
        return "".concat(this.$env.cdnUrl, "/user_arts/").concat(user.ipfs);
      }
      return '';
    },
    getGuildImg: function getGuildImg(user) {
      var guildInfo = [];
      if (user.guildId > 0) {
        guildInfo = this.guildInfos.find(function (g) {
          return g.guildId == user.guildId;
        });
      }
      if (!guildInfo) return '';
      if (!Object.keys(guildInfo).length) return '';
      if (guildInfo.ipfs.includes('.png')) return "".concat(this.$env.cdnUrl, "/static/land/guildicon/").concat(guildInfo.ipfs);else return "".concat(this.$env.cdnUrl, "/user_arts/").concat(guildInfo.ipfs);
    },
    guildIcon: function guildIcon(user) {
      return this.getGuildImg(user);
    },
    getLandClass: function getLandClass(user) {
      if (user.landType == 1) {
        return 'user_landType_agni';
      } else if (user.landType == 2) {
        return 'user_landType_sama';
      } else if (user.landType == 3) {
        return 'user_landType_vriksha';
      } else if (user.landType == 4) {
        return 'user_landType_atharva';
      } else if (user.landType == 5) {
        return 'user_landType_laVeda';
      } else if (user.landType == 6) {
        return 'user_landType_bariura';
      } else {
        return 'user_landType_none';
      }
    }
  }
};